import { SvgIcon, Loader, Input, Select, Toggle, PopoverMenu, SelectList, Pagination } from '@/components/ui'

export default {
  components: {
    SvgIcon,
    Loader,
    Input,
    Select,
    Toggle,
    PopoverMenu,
    SelectList,
    Pagination,
  },
}
